
export const LANGUAGE = function() {
    var browserLang = (navigator.browserLanguage || navigator.language).toLowerCase()
    switch (browserLang) {
        case 'zh-cn':
            return "zh-cn"
        case 'de-de':
        case 'de':
            return "de"
        case 'en':
        case 'en-us':
        case 'en-uk':
        case 'en-au':
            return "en"
        case "fr":
        case "fr-fr":
            return "fr"
        case "es":
        case "es-es":
            return "es"
        case "it":
        case "it-it":
            return "it"
        case "ja":
        case "ja-ja":
            return "jp"
        case "br":
        case "pt-br":
            return "br"
        default:
            // default English
            return "en"
    }
}()


const DevConfig = {
    version: "develop",
    url: "https://testai.tclking.com",
    address: "testai.tclking.com",
    clientId: "amzn1.application-oa2-client.0e98778e60db4e9c87985601a09a7ffc",
    productId: "king_device",
}

// const DevConfig = {
//     version: "develop",
//     url: "https://tuv-alexa-eu.tclking.com",
//     address: "tuv-alexa-eu.tclking.com",
//     clientId: "amzn1.application-oa2-client.0e98778e60db4e9c87985601a09a7ffc",
//     productId: "king_device",
// }


const ProductConfig = {
    version: "product",
    url: "https://ai.tclking.com",
    address: "ai.tclking.com",
    clientId: "amzn1.application-oa2-client.4caf5f724c00406e82eae396ea12166b",
    productId: "TCL_Smart_TV"
}

export const Config = DevConfig


//////////////////
// WEBPACK FOOTER
// ./src/config/config.js
// module id = null
// module chunks = 